module.exports = __webpack_public_path__ + "img/Otros desactivado.6f5c2447.svg";